
export const root = {
    gap: '0.5rem',
    transitionDuration: '{transition.duration}'
};

export default {
    root
};
